import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "../i18n/I18nContext";
import { listExtraconfigs } from "../services/payment";
import { listFrequencies } from "../services/teacher";
import { levelKey } from "../utils/classesLabels";

// Split out of the former ExtrasLayer. Same "hide cadastro from the menu"
// philosophy applied to ListaProdutosLayer: cadastro is only reachable via
// the "Adicionar Extra" button below (see CadastrarExtraLayer / App.js
// route `/pagamentos/extras/cadastrar`).
const ListaExtrasLayer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [frequencies, setFrequencies] = useState([]);
  const [extras, setExtras] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchExtras = () => {
    setLoading(true);
    listExtraconfigs()
      .then((resp) => setExtras(resp.data || []))
      .catch(() => toast.error(t("extra.error.load")))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    listFrequencies().then((resp) => setFrequencies(resp.data || [])).catch(() => setFrequencies([]));
    fetchExtras();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const levelName = (extra) => extra.level?.description || frequencies.find((f) => f.id === extra.levelId)?.description || "-";

  return (
    <div className='row gy-4'>
      <ToastContainer />

      <div className='col-12'>
        <div className='card radius-12'>
          <div className='card-body'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
              <div>
                <h6 className='mb-4'>{t("extra.section.list")}</h6>
                <p className='text-secondary-light mb-0 text-sm'>{t("extra.list.subtitle")}</p>
              </div>
              <button
                type='button'
                className='btn btn-primary-600 d-flex align-items-center gap-2'
                onClick={() => navigate("/pagamentos/extras/cadastrar")}
              >
                <Icon icon='ic:baseline-plus' />
                {t("extra.list.add")}
              </button>
            </div>

            {loading ? (
              <div className='text-center py-40'>{t("global.loading")}</div>
            ) : extras.length === 0 ? (
              <div className='alert alert-info mb-0'>{t("extra.hint.noExtras")}</div>
            ) : (
              <div className='table-responsive scroll-sm'>
                <table className='table bordered-table mb-0'>
                  <thead>
                    <tr>
                      <th scope='col'>{t("extra.field.name")}</th>
                      <th scope='col'>{t(levelKey("taxa.field.course"))}</th>
                      <th scope='col'>{t("extra.field.registrationAmount")}</th>
                      <th scope='col'>{t("extra.field.recuringAmount")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {extras.map((extra) => (
                      <tr key={extra.id}>
                        <td className='fw-semibold text-primary-light'>{extra.name}</td>
                        <td>{levelName(extra)}</td>
                        <td>{extra.registrationAmount || 0}</td>
                        <td>{extra.recuringAmount || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListaExtrasLayer;
